import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class MassSmsAPI {

  static list = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(`${Config.app.link}api/mass-sms/list`, new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(`${Config.app.link}api/mass-sms/${id}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static count = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/mass-sms/list/count', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (call, success, failure) => {
    fetch(Config.app.link + 'api/mass-sms/add-edit', new Header('POST', call))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/mass-sms/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default MassSmsAPI;